import React from 'react';
import warning from '../../uploads/warning.jpg';

const Disclaimer = () => {
  return (
    <div>
      <p style={{ marginTop: '20px', display: 'block', textAlign: 'justify' }}>
        <i>
          Настоящим я подтверждаю достоверность предоставленной информации и не возражаю против проверки предоставленных сведений.<br />
          Мен ушбу хужат билан берилган маълумотларнинг тўғрилигини тасдиқлайман ва берилган маълумотларнинг текширилишига эътироз билдирмайман.<br />
          Men ushbu hujat bilan berilgan ma'lumotlarning to'g'riligini tasdiqlayman va berilgan ma'lumotlarning tekshirilishiga e'tiroz bildirmayman
        </i>
      </p>
      <table style={{ marginTop: '30px' }}>
        <tbody>
          <tr>
            <td width="10%" style={{ verticalAlign: 'top' }}><img src={warning} style={{ width: '70px' }} alt="" /></td>
            <td width="90%"><p style={{ display: 'block', textAlign: 'justify' }}>
              <strong>Уважаемый кандидат,</strong> трудоустройство в Компанию «Enter Engineering Pte.Ltd.» является <strong>бесплатным</strong>, при попытках затребовать от Вас какие-либо денежные средства просим немедленно сообщать об этом на Горячую линию Компании по № +998 78 129 12 90 или telegram-bot - @HotlineEE_bot.<br /><br /><strong>Hurmatli nomzod</strong>, Enter Engineering Pte.Ltd. kompaniyasiga ishga joylashih <strong>bepul</strong>, agar sizdan biron-bir pul talab qilmoqchi bo'lsalar, Kompaniyaning  +998 78 129 12 90 raqamli ishonch telefoniga yoki @HotlineEE_ bot telegram botga darhol xabar berishingizni so'raymiz.
            </p></td>
          </tr>
          <tr>
            <td width="10%" style={{ verticalAlign: 'top' }}><img src={warning} style={{ width: '70px' }} alt="" /></td>
            <td width="90%"><p style={{ display: 'block', textAlign: 'justify' }}>
              <strong>DIQQAT:</strong> Ushbu so‘rovnoma «ENTER Engineering Pte. Ltd» Kompaniyning (keyingi oʻrinlarda: ENTER Engineering) mulkidir va nomzodlarga BEPUL tarqatiladi. Noto‘g‘ri to‘ldirilgan yoki to‘liq to‘ldirilmagan so‘rovnoma ko‘rib chiqilmaydi. Sizning nomzodligingiz ENTER Engineering’ni qiziqtirgan taqdirda Siz suhbatga taklif etilasiz.<br /><br /><strong>ВНИМАНИЕ:</strong> Данная анкета является собственностью Компания «ENTER Engineering Pte. Ltd» (далее: ENTER Engineering) и выдается кандидатам БЕСПЛАТНО. <br />Неправильно или недостаточно заполненная анкета не рассматривается.<br />В случае заинтересованности «ENTER Engineering» в Вашей кандидатуре, Вы будете приглашены на собеседование.
            </p></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Disclaimer;
